import { F, type Product } from '@hearingaid/shared'
import { ErrorText } from '../components/ErrorText'

/**
 * One `.product-card` per catalog hearing aid. Checkboxes, not radios, so the picked card can be
 * clicked off; picking another replaces it.
 */
export function ProductPicker({
  products,
  selected,
  onPick,
  error,
}: {
  products: Product[]
  selected: string | null
  onPick: (id: string, on: boolean) => void
  error: string | null
}) {
  return (
    <>
      <div className="products" role="group" aria-label="Hearing aid">
        {products.map((product, i) => {
          const picked = selected === product.id
          return (
            <label key={product.id} className={`product-card ${picked ? 'selected' : ''}`} data-product={product.id}>
              <span className="product-pick">
                <input
                  type="checkbox"
                  value={product.id}
                  checked={picked}
                  onChange={(e) => onPick(product.id, e.target.checked)}
                />{' '}
                Option {i + 1}
              </span>
              <img src={product.photo} alt={`${product.name}, ${product.style}`} />
              <strong className="product-name">{product.name}</strong>
              <span className="product-style">{product.style}</span>
            </label>
          )
        })}
      </div>
      <ErrorText field={F.product} errors={error === null ? [] : [{ field: F.product, message: error }]} />
    </>
  )
}
